import React from 'react';
import PropTypes from 'prop-types';
import amexSvg from '../../images/payment-methods/amex.svg';
import visaSvg from '../../images/payment-methods/visa.svg';
import klarnaSvg from '../../images/payment-methods/klarna.svg';
import paypalSvg from '../../images/payment-methods/pay-pal.svg';
import sofortSvg from '../../images/payment-methods/so-fort.svg';
import mastercardSvg from '../../images/payment-methods/mastercard.svg';

const IconsList = (props) => {
  let iconsList = [];
  const { iconsType } = props;

  switch (iconsType) {
    case 'payment':
      iconsList = [amexSvg, visaSvg, klarnaSvg, paypalSvg, sofortSvg, mastercardSvg];
      break;
    default:
      // For future icons that might be needed
      break;
  }

  return (
    <div>
      {iconsList.map((name) => {
        return <img src={name} key={Math.random()} alt={name} style={{ padding: '5px' }} />;
      })}
    </div>
  );
};

IconsList.propTypes = {
  iconsType: PropTypes.string,
  iconsList: PropTypes.arrayOf(PropTypes.any),
};

IconsList.defaultProps = {
  iconsType: null,
  iconsList: null,
};

export default IconsList;
